import React, { useEffect, useState } from 'react';
import { Box, Fade, Typography } from '@mui/material';
import { useAuth } from '../auth/AuthContext';
import { useSubscription } from './useSubscription';
import {
  clearTrialWelcomePending,
  hasSeenTrialWelcome,
  isTrialWelcomePending,
  markTrialWelcomeShown,
} from './trialWelcomeStorage';

const DISPLAY_MS = 4500;
const FADE_MS = 400;

const TrialWelcomeSplash = () => {
  const { user, authChecked } = useAuth();
  const { subscription, loading } = useSubscription();
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!authChecked || loading || !user || !subscription.isTrial) {
      if (authChecked && !loading && user && !subscription.isTrial) {
        clearTrialWelcomePending();
      }
      return;
    }

    if (!isTrialWelcomePending() || hasSeenTrialWelcome(user.id)) {
      clearTrialWelcomePending();
      return;
    }

    setMounted(true);
    setVisible(true);

    const hideTimer = window.setTimeout(() => setVisible(false), DISPLAY_MS);
    const unmountTimer = window.setTimeout(() => {
      markTrialWelcomeShown(user.id);
      setMounted(false);
    }, DISPLAY_MS + FADE_MS);

    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(unmountTimer);
    };
  }, [authChecked, loading, subscription.isTrial, user]);

  if (!mounted) {
    return null;
  }

  return (
    <Fade in={visible} timeout={FADE_MS}>
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: (theme) => theme.zIndex.modal + 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          px: 3,
          textAlign: 'center',
        }}
      >
        <Box sx={{ maxWidth: 420 }}>
          <Typography variant="h5" gutterBottom>
            Welcome to EndChess
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Your first three months are free with full access. Enjoy unlimited
            training while your trial is active.
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
};

export default TrialWelcomeSplash;
